import React from 'react';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import CalendarPicker from '@mui/lab/CalendarPicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { Box } from '@mui/material';


export default function When({ date, setDate }) {

  return (
    <Box
      sx={{
        bgcolor: 'white',
      }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CalendarPicker
          date={date}
          onChange={(newDate) => setDate(newDate)}
          minDate={new Date()}
        />
      </LocalizationProvider>
    </Box>
  );
}
